import React, { useEffect } from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import image from "../assests/services_image_3.jpg"
import { Link } from "react-router-dom";
import NewsletterSection from "./NewsLetter";
import HeroSection from "./HeroSection";

const Services3 = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navbar />
      
      {/* Hero Section */}
      {/* <div className="bg-customBlue text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div data-aos="fade-up" className="space-y-4 flex flex-col items-center text-center">
          <h1 className="font-nova-square text-4xl font-thin text-black">
          Mission Control Software for UCAV
          </h1>
          <p className="text-black">
          <Link to={"/"}> Home </Link>{' > '} <Link to={"/products"}>Products </Link> {'>'} <Link to={"/products/products3"}>Mission Control Software for UCAV </Link>
          </p>
        </div>
      </div>
      </div> */}

      <HeroSection
        title="Mission Control Software for UCAV" 
        breadcrumb={
          <>
            <Link to={"/products"}>Products</Link> {' > '} 
            <Link to={"/products/products3"}>Mission Control Software for UCAV</Link>
          </>
        } 
      />

      <div className="max-w-6xl mx-auto p-6">
        {/* Image Section */}
        <div className="flex flex-col md:flex-row items-center gap-8 max-w-6xl mx-auto">
      <div data-aos="zoom-in" className="md:w-1/2">
        <div className="relative group overflow-hidden rounded-xl shadow-2xl">
          <img
            src={image}
            alt="Mission Control Software"
            className="w-full h-[300px] object-cover transform transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      </div>
      {/* Introduction */}
      <div data-aos="fade-up" className="prose max-w-none md:w-1/2 space-y-5">
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
        Kristellar offers secured, end-to-end solutions for the drone and robotics industries. We support a diverse range of applications and operations in the most challenging and inaccessible urban and rural environments.
        </p>
        <hr className="border-gray-300 my-4" />
        <p className="text-lg text-gray-700 leading-relaxed text-justify">
        The know security parameters are not applicable for UAVs missions since these are involved with – decentralized control, wireless operation across remote vicinities, GNSS dependency, masses operation independently, physical vulnerability and the absence of cloud security – all contribute to their cyber exposure.
        </p>
      </div>
    </div>
      
      

        {/* Content Sections */}
        <div className="mt-12 space-y-8">
          {/* Introduction */}
          
          {/* CALISTO Overview */}
          <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <h2 className="font-nova-square text-2xl font-bold text-gray-800 mb-4">Autonomous Defense</h2>
            <p className="text-lg text-gray-700 text-justify">
            Kristellar iRiGEL ECI module is an AI-based 360° software cybersecurity system for drones, robotics, and autonomous platforms consists of Encryption, Crypto Key and Immunity, (ECI) as the first-of-its-kind multi-faceted and multi-tiers suite that autonomously protects the platform, safeguards communication channels and encrypts collected and transmitted data. The ECI module can defend against more than 9 different types of cyber breaches and malicious attacks, including jamming, man in the middle, CPU, Servers attacks, and more in real-time without requiring intervention by an operator.
            </p>
          </div>

          {/* Key Features */}
          <div data-aos="fade-up" className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: "Upgradeable Protection",
                description: "The ECI module offers flexibility during operations, allowing upgrades at any stage to enhance protection. By implementing Professional or Premium tiers through software license modules, the system ensures cost-effective, proactive defense. Emphasizing prevention over cure, it safeguards operations with long-term reliability.",
                icon: "🔄"
              },
              {
                title: "Multi-Tier Security",
                description: "Unlike conventional solutions, the iRiGEL ECI module provides different security tiers to maximize resistance against attacks. This approach makes it exceedingly challenging for cyber threats to disrupt operations, ensuring uninterrupted functionality in critical scenarios.",
                icon: "🔐"
              },
              {
                title: "Industrial-Grade Reliability",
                description: "Renowned as a preferred choice for industrial and military-grade applications, the iRiGEL ECI module excels in avionic, maritime, and ground-force unmanned platforms. With Kristellar’s decade-long expertise in digital security, it ensures robust and dependable solutions for even the most demanding environments.",
                icon: "⚙️"
              }
            ].map((feature, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 h-72 overflow-y-auto"
              >
                <div className="text-4xl mb-4">{feature.icon}</div>
                <h3 className="font-nova-square text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
                <p className="text-lg text-gray-600 text-justify">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Capabilities List */}
          {/* <div data-aos="fade-up" className="bg-white rounded-xl p-8 shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Key Capabilities</h2>
            <div className="grid md:grid-cols-2 gap-4">
              {[
                "Easy-to-use monitoring and control access",
                "Telecommands generation and management",
                "Non-Destructive Testing",
                "Aerospace Polymers and Plastics Testing",
                "Cloud-based AI mission control",
                "High-performance infrastructure",
                "Advanced encryption and authentication",
                "Mechanical Testing",
                "Aerospace Composites Testing"
              ].map((item, index) => (
                <div 
                  key={index}
                  className="flex items-center space-x-3 p-3 rounded-lg hover:bg-blue-50 transition-colors duration-300"
                >
                  <div className="h-2 w-2 rounded-full bg-blue-500" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>

      <NewsletterSection />
      <Footer />
    </div>
  );
};

export default Services3;